import { defineMessages } from 'react-intl';

export const messages: {
	ownerName: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	state: {
		// eslint-disable-next-line @atlassian/i18n/no-useless-message
		defaultMessage: string;
		description: string;
		id: string;
	};
	tier: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	tier: {
		id: 'dynamic-cards-search-page.compass.tier',
		defaultMessage: 'Tier {tier}',
		description:
			'Indicates how critical the component is to your business. The lower the tier, the higher the criticality.',
	},
	state: {
		id: 'dynamic-cards-search-page.compass.state',
		// eslint-disable-next-line @atlassian/i18n/no-useless-message
		defaultMessage: '{state}',
		description: 'Indicates if the component is in an active, pending or archived state.',
	},
	ownerName: {
		id: 'dynamic-cards-search-page.compass.owner-name',
		defaultMessage: 'Owned by {ownerName}',
		description: 'Indicates which team owns this component.',
	},
});
